export default __webpack_public_path__ + "static/image7-f68b32cc232c9b006cb87a2c42279f3e.jpg";